import { instance4 } from "App/constants";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const urlGet = LIST_URL_WAREHOUSE.inventoryControlLGS.get;
export const urlDelete = LIST_URL_WAREHOUSE.inventoryControlLGS.delete;

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  barang_name: "",
  gudang: "Pilih Gudang",
  gudang_id: "",
  id: "",
};

export const getByFilterInventory = async (formFilter, pages, limit) => {
  try {
    const api = await instance4.get(urlGet, {
      headers: {
        pages: pages,
        limit: limit,
        nama_barang: formFilter.barang_name,
        gudang_id: formFilter.gudang_id,
      },
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.meta.count),
          pages: parseInt(res.meta.pages),
          limit: parseInt(res.meta.limit),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID INVENTORY",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "barang_id",
    disablePadding: false,
    label: "ID BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaBarang",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaGudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "hargapokok",
    disablePadding: false,
    label: "HARGA POKOK",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "qty",
    disablePadding: false,
    label: "JML STOK",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "persediaan",
    disablePadding: false,
    label: "PERSEDIAAN",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "stockmin",
    disablePadding: false,
    label: "STOCK MIN",
    align: "left",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "stockmax",
    disablePadding: false,
    label: "STOCK MAX",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "nilaikritis",
    disablePadding: false,
    label: "STOCK KRITIS",
    align: "left",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const deleteInventoryControlByID = async (id) => {
  try {
    const res = await instance4.post(urlDelete, {
      id,
    });

    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};